<template>
  <div class="min-h-screen bg-[#f6f7f9] py-10">
    <div class="max-w-[900px] mx-auto px-6">
      <div class="bg-white rounded-2xl border border-[#e9eaec] shadow-sm overflow-hidden">
        <div class="h-1 bg-gradient-to-r from-[#FFD500] to-[#FFC107]"></div>
        <div class="px-8 py-10">

          <nav class="flex items-center gap-2 text-[0.82rem] text-[#999] mb-6">
            <router-link to="/" class="hover:text-[#111] transition-colors no-underline"><i class="bi bi-house"></i></router-link>
            <i class="bi bi-chevron-right text-[0.7rem]"></i>
            <span class="text-[#111] font-medium">Verzending & Retour</span>
          </nav>

          <h1 class="text-[2rem] font-extrabold text-[#111] mb-2 leading-tight">Verzending & Retour</h1>
          <p class="text-[0.9375rem] text-[#666] mb-8">Alles over levering, bezorging en ons retourbeleid.</p>

          <!-- USP banner -->
          <div class="grid sm:grid-cols-3 gap-3 mb-8">
            <div v-for="usp in usps" :key="usp.label" class="flex items-center gap-3 bg-[#fffbe6] rounded-xl p-4 border border-[#FFD500]/20">
              <i :class="usp.icon" class="text-[#FFD500] text-[1.25rem] shrink-0"></i>
              <div>
                <p class="font-bold text-[#111] text-[0.875rem] mb-0">{{ usp.label }}</p>
                <p class="text-[0.78rem] text-[#666] mb-0">{{ usp.sub }}</p>
              </div>
            </div>
          </div>

          <div class="prose-content">

            <h2>Verzendkosten</h2>
            <p>Wij verzenden binnen Nederland via PostNL of DHL.</p>
            <table>
              <thead>
                <tr><th>Bestelbedrag</th><th>Verzendkosten</th></tr>
              </thead>
              <tbody>
                <tr><td>Onder €50</td><td>€4,95</td></tr>
                <tr><td>Vanaf €50</td><td>Gratis</td></tr>
                <tr><td>Grote pakketten (laadpalen, batterijen)</td><td>€9,95</td></tr>
                <tr><td>België & Duitsland</td><td>€7,95</td></tr>
              </tbody>
            </table>

            <h2>Levertijd</h2>
            <p>De meeste producten zijn op voorraad en worden de volgende werkdag geleverd. Bestellingen geplaatst voor <strong>15:00 uur</strong> op werkdagen worden dezelfde dag verzonden.</p>
            <p>Na verzending ontvang je een track & trace per e-mail zodat je de levering kunt volgen.</p>

            <h2>Retourneren</h2>
            <p>Niet tevreden? Je hebt <strong>30 dagen bedenktijd</strong> na ontvangst. Producten dienen ongebruikt, in de originele verpakking te worden geretourneerd.</p>
            <p>Meld je retour via <a href="mailto:info@plug2charge.nl">info@plug2charge.nl</a> of bekijk ons volledige <router-link to="/retourneren">retourbeleid</router-link>.</p>

            <h2>Terugbetaling</h2>
            <p>Na ontvangst en controle van je retour wordt het bedrag binnen <strong>5 werkdagen</strong> teruggestort op je rekening.</p>

            <h2>Beschadigd of verkeerd product?</h2>
            <p>Ontvang je iets wat beschadigd of verkeerd is? Neem dan direct contact met ons op via <a href="mailto:info@plug2charge.nl">info@plug2charge.nl</a>. We lossen het zo snel mogelijk op.</p>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const usps = [
  { icon: 'bi bi-truck', label: 'Gratis verzending', sub: 'Vanaf €50 bestelling' },
  { icon: 'bi bi-lightning-charge', label: 'Snelle levering', sub: 'Bestel vóór 15:00' },
  { icon: 'bi bi-arrow-return-left', label: '30 dagen retour', sub: 'Gratis & makkelijk' },
]
</script>

<style scoped>
.prose-content :deep(h2) { font-size: 1.125rem; font-weight: 700; color: #111; margin-top: 1.75rem; margin-bottom: 0.625rem; padding-bottom: 0.375rem; border-bottom: 1px solid #f0f0f0; }
.prose-content :deep(p)  { font-size: 0.9375rem; color: #444; line-height: 1.7; margin-bottom: 0.875rem; }
.prose-content :deep(a)  { color: #b8860b; text-decoration: underline; }
.prose-content :deep(a:hover) { color: #111; }
.prose-content :deep(strong) { font-weight: 700; color: #333; }
.prose-content :deep(table) { width: 100%; border-collapse: collapse; margin-bottom: 1.25rem; }
.prose-content :deep(th) { background: #f8f9fa; font-weight: 700; text-align: left; padding: 0.625rem 0.875rem; border: 1px solid #e5e7eb; font-size: 0.875rem; }
.prose-content :deep(td) { padding: 0.625rem 0.875rem; border: 1px solid #e5e7eb; font-size: 0.9rem; color: #444; }
.prose-content :deep(tr:nth-child(even) td) { background: #fafafa; }
</style>
